/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Graphic1 } from './components/Graphic1'
import { Graphic2 } from './components/Graphic2'
import { Graphic3 } from './components/Graphic3'
import { Graphic4 } from './components/Graphic4'
import { Graphic5 } from './components/Graphic5'
import { FleetHealthHero } from './components/FleetHealthHero'
import { ChartWrapper, TOKENS } from '../../components/design-system'
import { SensorTransportProvider } from '../sensors-v2/transports/SensorTransportProvider'

// Reuses the existing Graphic* components. Each gets a consistent
// ChartWrapper so the labels, padding and surface treatment match the
// rest of the redesigned UI. The internal chart code is untouched.

const DashboardPage: FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: TOKENS.spacing.md }}>
      <FleetHealthHero />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gap: TOKENS.spacing.md,
        }}
      >
        <ChartWrapper label="Boxes × Intervenções" minHeight={240}>
          <Graphic1 key='boxes-vs-interventions' className='' chartColor='danger' chartHeight='200px' />
        </ChartWrapper>
        <ChartWrapper label="Intervenções por Usuário" minHeight={240}>
          <Graphic2 key='interventions-username' className='' chartColor='warning-active' chartHeight='200px' />
        </ChartWrapper>
        <ChartWrapper label="Erros por CMB" minHeight={240}>
          <Graphic3 key='total_erros-bux_number' className='' chartColor='info' chartHeight='200px' />
        </ChartWrapper>

        <div style={{ gridColumn: 'span 2' }}>
          <ChartWrapper label="Resumo geral" minHeight={320}>
            <Graphic5 key='summary' className='' chartColor='primary' chartHeight='280px' />
          </ChartWrapper>
        </div>
        <ChartWrapper label="Eventos por dia" minHeight={320}>
          <Graphic4 key='log_boxes-events' className='' chartColor='secondary' chartHeight='280px' />
        </ChartWrapper>
      </div>
    </div>
  )
}

const DashboardWrapper: FC = () => {
  return (
    <SensorTransportProvider transport="websocket">
      <DashboardPage />
    </SensorTransportProvider>
  )
}

export { DashboardWrapper }
